import type Item from 'owa-service/lib/contract/Item';
import { action } from 'satcheljs';
import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';

export default action(
    'updateLoadedItemState',
    function updateLoadedItemState(
        itemId: string,
        loadedItem: Item,
        itemReadingPaneViewState: ItemReadingPaneViewState
    ) {
        return { itemId, loadedItem, itemReadingPaneViewState };
    }
);
